<template>
    <div class="page-head" v-show="isShow">
        <div class="section-nav">
            <div class="header-inner commonMyWrap">
                <div class="headerItem" @mouseenter.stop="hoverGoods" @click.stop="goPage(0)">
                    {{ $t('产品') }}
                    <div class="headerSelectBigBox" v-show="showHeaderSelect">
                        <div class="headerSelectBigBoxClose" @mouseenter.stop="showHeaderSelect = false"></div>
                        <div class="headerSelectBox">
                            <div class="headerSelectBoxItem" v-for="(item, index) in list" :key="item.id" @click.stop="goListPage(item, 1)">
                                <el-popover
                                    disabled
                                    :visible-arrow="false"
                                    placement="right-start"
                                    width="200"
                                    trigger="hover"
                                    popper-class="headerPopper"
                                    :open-delay="0"
                                    :close-delay="0"
                                    :offset="0"
                                >
                                    <!-- 产品二级导航 -->
                                    <div class="selectFlexBox2" v-if="selectFlexBox2Show(item)">
                                        <div
                                            class="selectTitle2"
                                            v-for="(item2, index2) in selectFlexBox2List(item)"
                                            :key="item2.id"
                                            @click.stop="goListPage(item2, 2, item)"
                                            :class="{ nomt: index2 == 0 }"
                                        >
                                            {{ item2.title }}
                                        </div>
                                    </div>
                                    <!-- 产品一级导航 -->
                                    <div class="selectFlexBox" slot="reference">
                                        <img src="@/assets/img/head/selectIcon.png" class="selectIcon" alt="" />
                                        <div class="selectTitle">{{ lang == 'en' ? item.enTitle : item.title }}</div>
                                        <!-- <div class="selectGoIcon"></div> -->
                                    </div>
                                </el-popover>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="headerItem" v-if="lang == 'zh'" @mouseenter.stop="showHeaderSelect = false" @click="goPage(1)">{{ $t('私人定制') }}</div>
                <div class="headerItem" @mouseenter.stop="showHeaderSelect = false" @click="goPage(2)">{{ $t('签约艺术家') }}</div>
                <div class="headerLogo btn-ripple" @mouseenter.stop="showHeaderSelect = false" @click="goPage(3)"></div>
                <div class="headerItem" @mouseenter.stop="showHeaderSelect = false" @click="goPage(5)">{{ $t('新闻动态') }}</div>
                <div class="headerItem" @mouseenter.stop="showHeaderSelect = false" @click="goPage(4)">{{ $t('关于海伦') }}</div>
                <div class="headerItem" @mouseenter.stop="showHeaderSelect = false" @click="goPage(6)">{{ $t('联系我们') }}</div>

                <div class="btnTopFlexBox">
                    <div class="topBtnItem bg1" @click="headerBtn(0)"></div>
                    <div class="topBtnItem bg2" @click="headerBtn(1)"></div>
                    <div class="topBtnItem bg3" @click.stop="headerBtn(2)" v-if="lang == 'zh'">
                        <div class="loginReadyWin" v-if="vuex_is_login" @click.stop="$router.push('/my-index')">
                            <img :src="mix_user_avatar || avatar_default" class="headImg" alt="" />
                            <div class="rightBox">
                                <div class="name">{{ baseInfo.nickname }}</div>
                                <div class="loginOutText" @click.stop="logout()">退出</div>
                            </div>
                        </div>
                    </div>
                    <div class="topBtnItem bg4" @click="headerBtn(3)" v-if="lang == 'zh'"></div>
                    <div class="topBtnItem bg5" v-if="lang == 'zh'" @click="headerBtn(4)"></div>
                    <div class="topBtnItem bg6" v-else @click="headerBtn(4)"></div>
                </div>
            </div>
        </div>

        <!-- 分享弹窗 -->
        <div class="shareWin" v-show="shareWinShow">
            <div class="shareCloseWinBtn" @click="closeShareWin"></div>
            <div class="shareWinTitle">FOLLOW US</div>
            <div class="bottomLogoFlexBox">
                <div class="bottomLogo2 bg1" @click="bottomBtn(0)"></div>
                <div class="bottomLogo2 bg2" @click="bottomBtn(1)"></div>
                <div class="bottomLogo2 bg3" @click="bottomBtn(2)"></div>
                <div class="bottomLogo2 bg4" @click="bottomBtn(3)"></div>
                <div class="bottomLogo2 bg5" @click="bottomBtn(4)"></div>
                <div class="bottomLogo2 bg6" @click="bottomBtn(5)"></div>
            </div>
        </div>

        <!-- 搜索弹窗 -->
        <div class="searchWinBox" v-show="searchWinShow">
            <div class="searchCloseWin" @mouseenter="searchClose"></div>
            <div class="searchWin">
                <div class="sreachWinBox">
                    <div class="searchWinFlexBox">
                        <input type="text" class="searchWinInput" v-model="searchKeyword" :placeholder="$t('请输入搜索关键词')" />
                        <div class="searchWinRightBox">
                            <div class="searchTypeSelectBox">
                                <span class="searchTypeBtn" @click="searchTypeSwitch(0)" :class="{ active: searchType == 0 }">{{ $t('产品') }}</span>
                                &nbsp&nbsp/&nbsp&nbsp
                                <span class="searchTypeBtn" @click="searchTypeSwitch(1)" :class="{ active: searchType == 1 }">{{ $t('文章') }}</span>
                                &nbsp&nbsp/&nbsp&nbsp
                                <span class="searchTypeBtn" @click="searchTypeSwitch(2)" :class="{ active: searchType == 2 }">{{
                                    $t('艺术家')
                                }}</span>
                            </div>
                            <div class="queryBtn" @click="searchBtn"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { id1, id2, id3 } from '@/config/env.js'
export default {
    name: 'HeaderIndex',
    data() {
        return {
            isShow: true, // 导航栏是否显示
            shareWinShow: false, // 分享弹窗是否显示
            searchWinShow: false, // 搜索弹窗是否显示
            searchType: 0, // 搜索类型：0.产品，1.文章，2.艺术家

            list: [], // 一级产品列表

            showHeaderSelect: false,

            searchKeyword: '', // 搜索输入框
        }
    },
    computed: {
        ...mapState(['avatar_default', 'baseInfo']),
        selectFlexBox2Show() {
            function isArray(arg) {
                if (typeof Array.isArray === 'undefined') {
                    return Object.prototype.toString.call(arg) === '[object Array]'
                }
                return Array.isArray(arg)
            }
            return (item) => {
                if (isArray(item.pList) && item.pList.length > 0) {
                    return true
                } else if (item.id == id1 || item.id == id2 || item.id == id3) {
                    if (isArray(item.channels) && item.channels.length > 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            }
        },
        selectFlexBox2List() {
            function isArray(arg) {
                if (typeof Array.isArray === 'undefined') {
                    return Object.prototype.toString.call(arg) === '[object Array]'
                }
                return Array.isArray(arg)
            }
            return (item) => {
                if (isArray(item.pList)) {
                    return item.pList
                } else if (isArray(item.channels)) {
                    return item.channels
                } else {
                    return []
                }
            }
        },
    },
    watch: {
        '$route.path': {
            immediate: true,
            handler(newV) {
                // 定制鼓页面，隐藏顶部导航
                if (newV == '/product-made') {
                    this.isShow = false
                } else {
                    this.isShow = true
                }
            },
        },
    },
    created() {
        this.getChannel()
    },
    mounted() {},
    methods: {
        async getChannel() {
            let res = await this.productChannelAjax()
            if (res && res.code == 200) {
                let channelList = res.data
                for (let i = 0; i < channelList.length; i++) {
                    let item = channelList[i]
                    if (item.id != id1 && item.id != id2 && item.id != id3) {
                        // 二级分类是商品
                        let res2 = await this.productPlistAjax({
                            channelId: item.id,
                            page: 1,
                            pageNum: 99999,
                        })
                        if (res2 && res2.code == 200) {
                            let pList = res2.data.list ? res2.data.list : []
                            channelList[i].pList = pList
                        }
                    }
                }
                this.list = channelList
            }
        },
        async getPlist() {},
        hoverGoods() {
            this.showHeaderSelect = true
        },
        searchBtn() {
            if (this.searchKeyword == '') {
                alertErr(this.$t('请输入'))
                return
            }
            if (this.searchType == 0) {
                // 产品
                this.$router.push({
                    path: '/productListFirst',
                    query: {
                        keyword: this.searchKeyword,
                    },
                })
            } else if (this.searchType == 1) {
                // 文章
                this.$router.push({
                    path: '/news',
                    query: {
                        keyword: this.searchKeyword,
                    },
                })
            } else if (this.searchType == 2) {
                // 艺术家
                this.$router.push({
                    path: '/artistList',
                    query: {
                        keyword: this.searchKeyword,
                    },
                })
            }
            this.searchKeyword = ''
            this.searchWinShow = false
        },
        // 商品列表初始化
        async productListInit() {
            let res = await this.productChannelAjax({})
            if (res) {
                let list = res.data
                let arr = []
                for (let index = 0; index < list.length; index++) {
                    let item = list[index]
                    let obj2 = {
                        channelId: item.id,
                        page: 1,
                        pageNum: 99999,
                    }
                    let res2 = await this.productPlistAjax(obj2)
                    list[index].goods = res2.data.list ? res2.data.list : []
                }
                this.list = list
            }
        },
        productPlistAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'product_plist',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        productChannelAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'product_channel',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        // 去列表页
        goListPage(item, type, itemParent) {
            if (type == 1) {
                // 点击一级分类
                this.$router.push({
                    path: '/productListFirst',
                    query: {
                        id: item.id,
                        title: item.title,
                    },
                })
            } else if (type == 2) {
                // 点击二级分类
                if (itemParent && (itemParent.id == id1 || itemParent.id == id2 || itemParent.id == id3)) {
                    // 军鼓、硬件、配件，跳转二级分类
                    this.$router.push({
                        path: '/productListFirst',
                        query: {
                            id: item.id,
                            title: item.title,
                        },
                    })
                } else {
                    this.$router.push({
                        path: '/product-detail',
                        query: {
                            id: item.inventoryId,
                        },
                    })
                }
            }
        },
        searchClose() {
            this.searchKeyword = ''
            this.searchWinShow = false
        },
        // 搜索状态切换
        searchTypeSwitch(type) {
            this.searchType = type
            if (type == 0) {
                // 产品
            } else if (type == 1) {
                // 文章
            } else if (type == 2) {
                // 艺术家
            }
        },
        // 分享弹窗外链跳转
        bottomBtn(type) {
            if (type == 0) {
                // 微信
            } else if (type == 1) {
                // 视频号
            } else if (type == 2) {
                // 抖音
            } else if (type == 3) {
                //  小红书
            } else if (type == 4) {
                // 脸书
            } else if (type == 5) {
                // 推特
            }
        },
        headerBtn(type) {
            if (type == 0) {
                // 搜索
                if (this.searchWinShow) {
                    this.searchWinShow = false
                } else {
                    this.searchWinShow = true
                    this.searchType = 0
                }
            } else if (type == 1) {
                // 分享
                this.shareWinShow = true
                this.searchWinShow = false
            } else if (type == 2) {
                this.searchWinShow = false
                if (this.vuex_is_login) {
                    return
                }
                // 登录
                this.$router.push({
                    path: '/login',
                })
            } else if (type == 3) {
                this.searchWinShow = false
                // 注册
                this.$router.push({
                    path: '/register',
                })
            } else if (type == 4) {
                // 中英文切换
                this.searchWinShow = false
                if (this.$store.state.lang == 'zh') {
                    sessionStorage.setItem('lang', 'en')
                } else {
                    sessionStorage.setItem('lang', 'zh')
                }
                this.$store.commit('clear_loginInfo')
                window.location.href = window.location.hostname
                // this.$router.push('/')
                // setTimeout(() => {
                //     window.location.reload()
                // }, 100)
            }
        },
        closeShareWin() {
            this.shareWinShow = false
        },
        goPage(type) {
            if (type == 0) {
                // 产品系列
                this.$router.push({
                    path: '/productListFirst',
                })
            } else if (type == 1) {
                // 私人定制
                this.$router.push({
                    path: '/product-made',
                })
            } else if (type == 2) {
                // 签约艺术家
                this.$router.push({
                    path: '/artistList',
                })
            } else if (type == 3) {
                // 首页
                this.$router.push({
                    path: '/',
                })
            } else if (type == 4) {
                // 关于海伦
                this.$router.push({
                    path: '/about',
                })
            } else if (type == 5) {
                // 新闻动态
                this.$router.push({
                    path: '/news',
                })
            } else if (type == 6) {
                // 联系我们
                this.$router.push({
                    path: '/contact',
                })
            }
        },
        logout() {
            this.$store.commit('clear_loginInfo')
            this.$router.push('/login')
            alertSucc('退出成功')
        },
    },
}
</script>

<style lang="less" scoped>
.w-nav-popover .popper__arrow {
    display: none !important;
}

.w-nav-popover {
    padding: 0 !important;
    margin-top: 2px !important;
    // border: none !important;
}

.pop-child {
    .child-item {
        text-align: center;
        display: block;
        height: 40px;
        line-height: 40px;

        background: #fff;
        font-size: 14px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #000000;

        &:hover {
            background: #4ca5e4;
            color: #fff;
        }
    }
}
</style>

<style lang="less">
//最外层div,修改背景色，边框
.el-popover.headerPopper {
    background: rgba(136, 136, 136, 1);
    border: none;
    padding: 30px;
    border-radius: 0;
    position: relative;
}

//修改title颜色
.headerPopper .el-popover__title {
    color: white;
}
//修改下面的小三角，属性名根据组件的placement位置做相应修改
.headerPopper .popper__arrow::after {
    display: none !important;
    border-top-color: transparent !important;
}

.headerPopper .popper__arrow {
    display: none !important;
}
</style>

<style scoped lang="less">
.headerSelectBoxItem {
    position: relative;
    margin-bottom: 25px;

    &:last-child {
        margin-bottom: 0;
    }
}

.selectFlexBox2 {
    max-height: 50vh;
    overflow-y: auto;
    overflow-x: hidden;
    word-break: break-all;
    padding-right: 10px;

    &::-webkit-scrollbar {
        width: 10px;
    }
    &::-webkit-scrollbar-track {
        // 背景
        background-color: #f1f1f1;
    }
    &::-webkit-scrollbar-thumb {
        // 滚动块
        background-color: #a8a8a8;
    }

    .selectTitle2 {
        width: 140px;
        display: block;
        font-size: 17px;
        line-height: 27px;
        color: #ffffff;
        margin-top: 25px;
        position: relative;
        cursor: pointer;
        word-break: break-all;
        padding-right: 16px;

        &.nomt {
            margin-top: 0;
        }

        &:hover {
            display: block;
            color: #ff4d00;
        }

        // &:first-child {
        //     margin-top: 0;
        // }

        // &:after {
        //     content: '';
        //     position: absolute;
        //     top: -10px;
        //     right: -30px;
        //     bottom: -10px;
        //     left: -30px;
        // }
    }
}

.headerSelectBigBox {
    position: fixed;
    top: 160px;
    left: 0px;
    width: 100vw;
    height: calc(100vh - 160px);
}

.headerSelectBigBoxClose {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.headerSelectBox {
    overflow-x: hidden;
    overflow-y: auto;
    background: rgba(0, 0, 0, 0.7);
    padding: 20px;
    max-height: calc(80vh - 160px);
    position: absolute;
    top: 0px;
    left: 50%;
    transform: translateX(-800px);

    // &::-webkit-scrollbar {
    //     width: 10px;
    // }
    // &::-webkit-scrollbar-track {
    //     // 背景
    //     background-color: #f1f1f1;
    // }
    // &::-webkit-scrollbar-thumb {
    //     // 滚动块
    //     background-color: #a8a8a8;
    // }

    .selectFlexBox {
        display: flex;
        align-items: center;
        margin-bottom: 25px;
        position: relative;
        padding-right: 34px;

        .selectTitle {
            font-size: 16px;
            line-height: 26px;
            color: #ffffff;
            font-weight: normal;
            flex-shrink: 0;
            margin-right: 16px;
            white-space: nowrap;
            min-width: 20px;
        }

        .selectIcon {
            flex-shrink: 0;
            width: 26px;
            display: block;
            opacity: 0;
            margin-right: 14px;
        }

        .selectGoIcon {
            width: 9px;
            height: 16px;
            background: url('../../assets/img/head/go.png') no-repeat;
            background-size: 100% 100%;
            display: block;
        }

        &:last-child {
            margin-bottom: 0;
        }

        &:hover {
            .selectFlexBox2 {
                display: block;
            }

            .selectTitle {
                color: #ff4d00;
                font-weight: normal;
                flex-shrink: 0;
                white-space: nowrap;
            }

            .selectIcon {
                opacity: 1;
            }

            .selectGoIcon {
                background: url('../../assets/img/head/goActive.png') no-repeat;
                background-size: 100% 100%;
            }
        }

        &::after {
            content: '';
            position: absolute;
            top: -10px;
            right: -48px;
            bottom: -10px;
            left: 0px;
            z-index: 9999;
        }
    }
}

.page-head {
    position: sticky;
    z-index: 100;
    top: 0;
    left: 0;
    right: 0;
    line-height: 0;
    padding: 0;
    height: 160px;
    // border-bottom: 4px solid #009a44;
    // box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.16);
    background: #ffffff;

    .section-nav {
        height: 100%;
        box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
    }
}

.header-inner {
    position: relative;
    width: 1600px;
    height: 160px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .topLogoBox {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .topLogo {
        width: 120px;
        display: block;
    }

    .btnTopFlexBox {
        width: 248px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        position: absolute;
        top: 16px;
        right: 0;

        .topBtnItem {
            width: 40px;
            height: 40px;
            background: #ffffff;
            border-radius: 50%;
            cursor: pointer;
            position: relative;
            margin-right: 10px;

            &:last-child {
                margin-right: 0;
            }

            .loginReadyWin {
                display: none;
                width: 200px;
                height: 80px;
                background: #ffffff;
                box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
                border-radius: 8px 8px 8px 8px;
                align-items: center;
                justify-content: center;
                position: absolute;
                z-index: 99;
                bottom: -90px;
                left: 50%;
                transform: translateX(-50%);

                .headImg {
                    width: 40px;
                    height: 40px;
                    display: block;
                    margin-right: 12px;
                    border-radius: 50%;
                }

                .rightBox {
                    .name {
                        width: 100px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        font-size: 14px;
                        line-height: 14px;
                        color: #666666;
                    }

                    .loginOutText {
                        margin-top: 10px;
                        width: 100px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        font-size: 14px;
                        line-height: 14px;
                        color: #666666;
                        position: relative;
                        z-index: 99;
                    }
                }
            }

            .loginReadyWin::after {
                content: '';
                position: absolute;
                top: -20px;
                right: 0px;
                bottom: 0px;
                left: 0px;
            }
        }

        .topBtnItem.bg1 {
            background: url(../../static/header/search.png) no-repeat;
            background-size: 100% 100%;
        }

        .topBtnItem.bg2 {
            background: url(../../static/header/share.png) no-repeat;
            background-size: 100% 100%;
        }

        .topBtnItem.bg3 {
            background: url(../../static/header/login.png) no-repeat;
            background-size: 100% 100%;
        }

        .topBtnItem.bg3:hover {
            .loginReadyWin {
                display: flex;
            }
        }

        .loginReadyWin:hover {
            display: flex;
        }

        .topBtnItem.bg4 {
            background: url(../../static/header/sign.png) no-repeat;
            background-size: 100% 100%;
        }

        .topBtnItem.bg5 {
            background: url(../../static/header/en.png) no-repeat;
            background-size: 100% 100%;
        }

        .topBtnItem.bg6 {
            background: url(../../static/header/zh.jpg) no-repeat;
            background-size: 100% 100%;
        }

        .topBtnItem.bg1:hover {
            background: url(../../static/header/search2.png) no-repeat;
            background-size: 100% 100%;
        }

        .topBtnItem.bg2:hover {
            background: url(../../static/header/share2.png) no-repeat;
            background-size: 100% 100%;
        }

        .topBtnItem.bg3:hover {
            background: url(../../static/header/login2.png) no-repeat;
            background-size: 100% 100%;
        }

        .topBtnItem.bg4:hover {
            background: url(../../static/header/sign2.png) no-repeat;
            background-size: 100% 100%;
        }

        .topBtnItem.bg5:hover {
            background: url(../../static/header/en2.png) no-repeat;
            background-size: 100% 100%;
        }

        .topBtnItem.bg6:hover {
            background: url(../../static/header/zh2.png) no-repeat;
            background-size: 100% 100%;
        }
    }

    .logo-wrap {
        display: flex;
        align-items: center;

        .logo-box {
            cursor: pointer;

            img {
                width: 141px;
                height: 82px;
            }
        }
    }

    .nav-wrap {
        flex: 1;
        margin-top: 50px;
        // margin-left: 60px;
        // margin-right: 92px;
    }

    .nav-list {
        height: 100%;

        .nav-item {
            // flex: 1;
            text-align: center;

            &.nav-item-static {
                position: static;
            }

            .nav-link {
                position: relative;
                display: inline-block;
                height: 50px;
                font-size: 18px;
                line-height: 18px;
                color: #333333;
                font-weight: normal;

                &::after {
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translate(-50%);
                    width: 0;
                    height: 2px;
                    background: #4ca5e4;
                    transition: 0.3s;
                }
            }

            &:hover {
                .nav-link::after {
                    width: 36px;
                }
            }

            &.active {
                .nav-link {
                    color: #4ca5e4;

                    &::after {
                    }
                }
            }

            a {
                color: #222;
                width: 100%;
                font-size: 16px;
                font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                font-weight: 400;
                color: #333;
            }
        }
    }
}

.user-act {
    width: 440px;
    width: fit-content;
}

.center-search-wrap {
    position: relative;
    margin-right: 25px;

    &:hover {
        .search-suggest-list {
            display: block;
        }
    }

    .center-search {
        width: 270px;
        border-bottom: 1px solid #999999;

        .flex();
        align-items: stretch;
        border-radius: 5px;
        position: relative;
        overflow: hidden;

        .search-box {
            // border: 1px solid #aaa;
            .flex();
            overflow: hidden;
            // height: 100%;

            input {
                display: block;
                width: 317px;
                height: 38px;
                padding-left: 10px;

                &::-webkit-input-placeholder {
                    font-weight: normal;
                    font-size: 14px;
                    color: #909090;
                }
            }

            .btn-search {
                .flex-center();
                position: absolute;
                right: 0;
                width: 40px;
                height: 40px;
                background: #4ca5e4;
                border-radius: 0px 6px 6px 0px;
                font-weight: normal;
                font-size: 16px;
                color: #ffffff;
                background: transparent;

                &:hover {
                    opacity: 1 !important;
                }

                .img-search {
                    width: 20px;
                    height: 20px;
                    cursor: pointer;
                    transition: 0.3s;
                    margin-right: 11px;

                    &:hover {
                        opacity: 0.85;
                    }
                }
            }
        }
    }

    .search-suggest-list {
        display: none;
        position: absolute;
        z-index: 100;
        left: 0;
        right: 0;
        top: 43px;
        border: 1px solid #ddd;
        border-top: none;
        background: #fff;
        border-radius: 6px;
        overflow: hidden;

        .search-suggest-item {
            .ellipsis-1();
            line-height: 3.5rem;
            height: 3.5rem;
            padding: 0 5px;
            text-align: left;
            transition: 0.3s;

            &:hover {
                background: #f5f5f5;
            }

            a {
                .ellipsis-1();
                display: block;
                width: 100%;
                height: 100%;
                color: #888;
                font-size: 1.3rem;

                &:hover {
                    color: #4ca5e4;
                }
            }
        }
    }
}

.info-right {
    .flex();

    .log-box {
        .flex();
    }

    a {
        color: #fff;
        .flex();

        img {
            width: 30px;
            height: 30px;
        }
    }

    .user-login {
        width: 30px;
        height: 30px;
    }

    .user-reg {
        margin: 0 16px;
        width: 30px;
        height: 30px;
    }

    .cart-image {
        width: 30px;
        height: 30px;
    }

    .shopcart {
        position: relative;
        width: 30px;
        height: 30px;
        .flex-center();

        img {
            width: 30px;
            height: 30px;
        }

        .cart-num {
            .flex-center();
            position: absolute;
            right: -10px;
            top: -10px;
            min-width: 18px;
            padding: 0 3px;
            background: #ff3b30;
            border: 1px solid #ffffff;
            border-radius: 50%;
            font-size: 12px;
        }
    }
}

.user-login-info {
    position: absolute;
    right: 0;
    top: 12px;

    .avatar-box {
        width: 35px;
        height: 35px;
        border-radius: 50%;
        overflow: hidden;
        cursor: pointer;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .phone {
        margin: 0 16px;
        font-family: Arial, Arial;
        font-weight: 400;
        font-size: 16px;
        color: #999999;

        &:hover {
            color: #4ca5e4;
        }
    }

    .logout {
        font-family: Arial, Arial;
        font-weight: 400;
        font-size: 16px;
        color: #999999;

        &:hover {
            color: #4ca5e4;
        }
    }
}

.headerItem {
    font-size: 18px;
    line-height: 18px;
    font-weight: 500;
    color: #333333;
    cursor: pointer;
    position: relative;
}

.headerItem:hover {
    color: #ff4d00;
}

.headerItem::after {
    position: absolute;
    content: '';
    top: -10px;
    left: -10px;
    right: -80px;
    bottom: -80px;
}

.headerLogo {
    width: 120px;
    height: 140px;
    background: url(../../static/header/logoOrange.png) no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
}

.btn-ripple {
    vertical-align: bottom;
}

.btn-ripple:not(:disabled):hover {
    opacity: 1;
    position: relative;
    overflow: hidden;

    &::before {
        animation: ani_ripple 0.75s;
        z-index: 1;
        content: '';
        position: absolute;
        display: block;
        transition: all 0.6s;
        width: 100%;
        height: 0;
        border-radius: 50%;
        left: 50%;
        top: 50%;
        padding-top: 100%;
        transform: translateX(-50%) translateY(-50%);
    }
}

@keyframes ani_ripple {
    0% {
        background: rgba(0, 0, 0, 0.25);
        transform: translateX(-50%) translateY(-50%) scale(0);
    }

    to {
        background: transparent;
        transform: translateX(-50%) translateY(-50%) scale(1);
    }
}

@media screen and (max-width: 1600px) {
    .header-inner .nav-list .nav-item {
        margin-left: 10px;
        min-width: 80px;
    }

    .left-select {
        width: 160px !important;
    }
}

@media screen and (max-width: 1520px) {
    .header-inner .nav-list .nav-item {
        margin-left: 10px;
        min-width: 80px;
    }

    .left-select {
        width: 150px !important;
    }
}

.shareWin {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.9);
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .shareWinTitle {
        font-size: 70px;
        line-height: 70px;
        color: #ffffff;
        font-family: 'myTextStyle';
        margin-bottom: 68px;
    }

    .shareCloseWinBtn {
        width: 45px;
        height: 45px;
        position: absolute;
        right: 50px;
        top: 30px;
        background: url('../../assets/img/index/close.png') no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
    }

    .bottomLogoFlexBox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        margin-top: 68px;

        .bottomLogo2 {
            width: 29px;
            height: 29px;
            display: block;
            margin-right: 32px;
            cursor: pointer;

            .bottomLogoImg {
                width: 100%;
            }
        }

        .bottomLogo2.bg1 {
            background: url('../../assets/img/head/wx.png') no-repeat;
            background-size: 100% 100%;
        }

        .bottomLogo2.bg2 {
            background: url('../../assets/img/head/sph.png') no-repeat;
            background-size: 100% 100%;
        }

        .bottomLogo2.bg3 {
            background: url('../../assets/img/head/dy.png') no-repeat;
            background-size: 100% 100%;
        }

        .bottomLogo2.bg4 {
            background: url('../../assets/img/head/xhs.png') no-repeat;
            background-size: 100% 100%;
        }

        .bottomLogo2.bg5 {
            background: url('../../assets/img/head/ls.png') no-repeat;
            background-size: 100% 100%;
        }

        .bottomLogo2.bg6 {
            background: url('../../assets/img/head/tt.png') no-repeat;
            background-size: 100% 100%;
        }

        .bottomLogo2.bg1:hover {
            background: url('../../assets/img/head/wx2.png') no-repeat;
            background-size: 100% 100%;
        }

        .bottomLogo2.bg2:hover {
            background: url('../../assets/img/head/sph2.png') no-repeat;
            background-size: 100% 100%;
        }

        .bottomLogo2.bg3:hover {
            background: url('../../assets/img/head/dy2.png') no-repeat;
            background-size: 100% 100%;
        }

        .bottomLogo2.bg4:hover {
            background: url('../../assets/img/head/xhs2.png') no-repeat;
            background-size: 100% 100%;
        }

        .bottomLogo2.bg5:hover {
            background: url('../../assets/img/head/ls2.png') no-repeat;
            background-size: 100% 100%;
        }

        .bottomLogo2.bg6:hover {
            background: url('../../assets/img/head/tt2.png') no-repeat;
            background-size: 100% 100%;
        }

        .bottomLogo2:last-child {
            margin-right: 0;
        }
    }
}

.searchWinBox {
    width: 100%;
    height: 400px;
    position: fixed;
    top: 160px;
    left: 0;

    .searchCloseWin {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
    }

    .searchWin {
        z-index: 2;
        width: 100%;
        height: 120px;
        background: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;

        .sreachWinBox {
            width: 866px;
            height: 40px;
            border-bottom: 1px solid #000000;

            .searchWinFlexBox {
                width: 100%;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 16px 0;
                overflow: hidden;

                .searchWinInput {
                    width: 600px;
                    font-size: 16px;
                    line-height: 38px;
                    color: #444444;
                }

                .searchWinRightBox {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                }

                .queryBtn {
                    width: 20px;
                    height: 20px;
                    background: url('../../assets/img/head/searchBlack.png') no-repeat;
                    background-size: 100% 100%;
                    cursor: pointer;
                }

                .searchTypeSelectBox {
                    margin-right: 20px;
                    font-size: 16px;
                    line-height: 16px;
                    color: #555555;

                    .searchTypeBtn {
                        cursor: pointer;
                        font-size: 16px;
                        line-height: 16px;
                        color: #555555;

                        &.active {
                            color: #ff4d00;
                        }

                        &:hover {
                            color: #ff4d00;
                        }
                    }
                }
            }
        }
    }
}
</style>

<style scoped lang="less" src="@/assets/h5css/zujian/pageHeader.less"></style>
